import { render, staticRenderFns } from "./TradeMain.vue?vue&type=template&id=0e645c94&scoped=true"
import script from "./TradeMain.vue?vue&type=script&lang=ts"
export * from "./TradeMain.vue?vue&type=script&lang=ts"
import style0 from "./TradeMain.vue?vue&type=style&index=0&id=0e645c94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e645c94",
  null
  
)

export default component.exports